/** @format */

export const OPEN_UNIVERSITY_FEATURES_ENABLED_FOR_STUDENT_DEFAULT = false;
export const CROSS_STUDY_FEATURES_ENABLED_FOR_STUDENT_DEFAULT = false;
